import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Button,
} from "@material-ui/core";
import { useMainContext } from "../../context/MainContextProvider";

const ProductDetail = ({ open, onCloseClick }) => {
  const { selectedProduct } = useMainContext();
  const { image_large, videoUrl } = selectedProduct || {};
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    setShowVideo(false);
  }, [selectedProduct]);

  const getYoutubeEmbedUrl = (url) => {
    if (!url) return null;

    const shortMatch = url.match(/youtu\.be\/([^?&]+)/);
    if (shortMatch?.[1]) {
      return `https://www.youtube.com/embed/${shortMatch[1]}`;
    }

    const watchMatch = url.match(/v=([^?&]+)/);
    if (watchMatch?.[1]) {
      return `https://www.youtube.com/embed/${watchMatch[1]}`;
    }

    return null;
  };

  const youtubeEmbedUrl = getYoutubeEmbedUrl(videoUrl);
  const hasVideo = Boolean(videoUrl);

  return (
    <Dialog open={open} maxWidth="lg">
      <DialogContent>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
          }}
        >
          {hasVideo && showVideo ? (
            youtubeEmbedUrl ? (
              <iframe
                src={youtubeEmbedUrl}
                title="Product video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ width: "100%", minHeight: 300, maxHeight: 800 }}
              />
            ) : (
              <video
                src={videoUrl}
                controls
                style={{ maxWidth: "100%", maxHeight: 800 }}
              />
            )
          ) : (
            <img
              src={image_large}
              alt="Product"
              style={{ maxWidth: "100%", maxHeight: 800 }}
            />
          )}
          {hasVideo && (
            <Typography variant="body2" color="primary">
              <Button
                color="primary"
                size="small"
                onClick={() => setShowVideo((prev) => !prev)}
              >
                {showVideo ? "Show Image" : "Show Video"}
              </Button>
            </Typography>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseClick}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductDetail;
